import { Webhook } from '@nemuru-eng/js-api-client';

import { AddOrEditWebhookFormType } from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';

export const getWebhookAuthorization = (webhook: Webhook | AddOrEditWebhookFormType) => {
  if ('authorization' in webhook && webhook.authorization?.url)
    return {
      authorizationType: AuthorizationType.OAUTH_2 as const,
      authorization: webhook.authorization,
    };
  if ('authorizationHeader' in webhook && webhook.authorizationHeader)
    return {
      authorizationType: AuthorizationType.BASIC as const,
      authorizationHeader: webhook.authorizationHeader,
    };
  return {
    authorizationType: AuthorizationType.NO_AUTH as const,
  };
};
